export const ONBOARDING_BLOG_TREE = {
	BLOG_TREE_HEADER_SPOTLIGHT_DISMISSED_KEY:
		'blog-tree-onboarding:blogTreeHeaderChangeboardingSpotlightDismissed',
	BLOGS_TOGGLED_OFF_CHANGEBOARDING_DISMISSED_KEY:
		'blog-tree-onboarding:blogsToggledOffByPTLChangeboardingDismissed',
};
